<dashboard-dialog-frame [header]="'Dashboard settings'" [dialogRef]='dialogRef' [actions]="actions">

	<div class='dashboard-settings-dialog-content'>
		Settings go here...
	</div>

</dashboard-dialog-frame>